<template>
    <div class="page update-tel">

        <div class="title">
            填写新的手机号
        </div>

        <div class="content">
            <van-cell-group>
                <van-field
                    class="content-box"
                    label-class="content-title"
                    label-width="56px"
                    round
                    :border="false"
                    v-model="tel"
                    label="+86"
                    @keyup="bankCardKeyup"
                    placeholder="请输入手机号"
                    maxlength="13"
                />
            </van-cell-group>
        </div>

        <div class="control">
            <van-button type="danger" @click="sendVerify()" color="#D3172E" round size="large">继续</van-button>
            <div class="control-footer" @click="$router.back()">
                <img src="/static/img/icon_mycenter_back.svg" alt="">返回上一页
            </div>
        </div>

    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                active: 1,
                banners:[],
                recommend:[],
                articles:[],
                tel:"",
                radio : 1,
                checked:true,
            }
        },
        methods: {
            bankCardKeyup(){
                this.tel = this.tel.replace(/\s/g,'')
                    .replace(/[^\d]/g,'')
                    .replace(/(\d{3})(?=\d)/,'$1 ')
                    .replace(/(\d{3}) (\d{4})(?=\d)/,'$1 $2 ')
            },
            sendVerify(){
                let phoneValue = this.tel;
                if (phoneValue === '') {
                    this.$toast.fail('请填入新手机号');
                }else {
                    Interface.getData('get',Interface.user.send_verify, { mobile: phoneValue.replace(/ /g,"") })
                        .then(res => {
                            if (res.code !== -1) {
                                this.$router.push({
                                    name : 'my=send-verify',
                                    query: {tel:phoneValue}
                                })
                            }
                        })
                }
            }
        },
        created() {
            Interface.getShareInfo(this,"","","")
        }
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/update-tel/index.vue